import BaseIconAI from 'app/assets/icons/SmartDocs/BaseIconAI.svg'
import { Alert, Box, Flex } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'

function SmartDocsAlertBox({
  alertText = 'SmartDocs will help speed up your application. Your details will still be reviewed by the Property Manager once submitted',
}) {
  return (
    <Alert variant="blueWithBg">
      <Flex alignItems="center">
        <img
          src={BaseIconAI}
          alt="SmartDocs AI Icon"
          width={theme.width[6] + 'px'}
          height={theme.height[6] + 'px'}
        />
        <Box ml={4} fontSize={theme.fontSizes.pRegular14}>
          {alertText}
        </Box>
      </Flex>
    </Alert>
  )
}

export default SmartDocsAlertBox
